<template>
    <span>
        
        <b-overlay :show="loading.subscriptionInformation" rounded="sm">
            
            <b-form>
                
                <b-form-row>
                    <b-col>
                        
                        

                        <!-- <b-table 
                            striped hover 
                            :fields="subscriptionTable.fields"
                            :items="subscriptionTable.items"></b-table>
                        
                        {{subscriptionDetails.created}}<br/>
                        {{subscriptionDetails.start}}<br/>
                        {{subscriptionDetails.end}}<br/>
                        {{subscriptionDetails.data}} -->


                        

                    </b-col>
                </b-form-row>

                <!-- Free tier message -->
                <b-form-row v-if="localUserData.subscriptionTier == 'free' && !(subscriptionDetails.data && subscriptionDetails.data.data && subscriptionDetails.data.data.cancel_at_period_end)">
                    <b-col>
                        <p>Your current subscription is {{subscriptionName}}.  Consider upgrading to a paid subscription for access to premium features.</p>
                    </b-col>
                </b-form-row>
                
                <!-- App Store managed subscription message -->
                <b-form-row v-if="localUserData.subscriptionTier == 'paid' && (localUserData.subscriptionLevel == '$rc_annual' || localUserData.subscriptionLevel == '$rc_monthly') && !(subscriptionDetails.data && subscriptionDetails.data.data && subscriptionDetails.data.data.cancel_at_period_end)">
                    <b-col>
                        <b-alert show variant="info" class="mb-0">
                            <h5>Subscription Managed by App Store</h5>
                            <p class="mb-2">Your current subscription is <strong>{{subscriptionName}}</strong>.</p>
                            <p class="mb-0">This subscription is managed through your device's app store. To make changes to your subscription, including upgrades, downgrades, or cancellations, please visit:</p>
                            <ul class="mt-2 mb-0">
                                <li><strong>iOS:</strong> Settings → [Your Name] → Subscriptions, or open the Apple App Store app</li>
                                <li><strong>Android:</strong> Open the Google Play Store app → Menu → Subscriptions</li>
                            </ul>
                        </b-alert>
                    </b-col>
                </b-form-row>
                
                <!-- Stripe managed subscription message -->
                <b-form-row v-if="localUserData.subscriptionTier == 'paid' && localUserData.subscriptionLevel != '$rc_annual' && localUserData.subscriptionLevel != '$rc_monthly' && !(subscriptionDetails.data && subscriptionDetails.data.data && subscriptionDetails.data.data.cancel_at_period_end)">
                    <b-col>
                        <p v-if="subscriptionDetails.status === 'canceled'">
                            Your subscription to {{subscriptionName}} was cancelled on {{subscriptionDetails.cancelAt}}.
                        </p>
                        <p v-else>
                            Your current subscription is {{subscriptionName}}.  
                            It was created on {{subscriptionDetails.created}} and 

                            <span v-if="subscriptionDetails.cancelAt">
                                it will be cancelled automatically on {{subscriptionDetails.cancelAt}}.
                            </span>

                            <span v-else>
                                it will automatically renew on {{subscriptionDetails.end}}.
                            </span>
                        </p>
                    </b-col>
                </b-form-row>
                
                <!-- Show cancellation scheduled message -->
                <b-form-row v-if="subscriptionDetails.data && subscriptionDetails.data.data && subscriptionDetails.data.data.cancel_at_period_end">
                    <b-col>
                        <b-alert show variant="warning" class="mb-0">
                            <h5>Your subscription is scheduled to be cancelled</h5>
                            <p>Your current subscription is {{getCurrentSubscriptionName()}}. It was created on {{subscriptionDetails.created}} and will be cancelled on {{subscriptionDetails.cancelAt}}. You will continue to have access to premium features until then.</p>
                            <p>If you've changed your mind, you can reinstate your subscription by clicking the button below.</p>
                            <b-button variant="primary" @click="reinstateSubscription">Reinstate Subscription</b-button>
                        </b-alert>
                    </b-col>
                </b-form-row>
                
                <b-form-row v-if="localUserData.subscriptionLevel != '$rc_annual' && localUserData.subscriptionLevel != '$rc_monthly' && !(subscriptionDetails.data && subscriptionDetails.data.data && subscriptionDetails.data.data.cancel_at_period_end)">
                    <b-col>

                        <b-card-group>
                            
                            <ChangeSubscription
                                :subscriptionDetails="subscriptionDetails"
                                :userData="userData"
                                @subscriptionUpdated:ChangeSubscription="handleSubscriptionUpdated"/>

                            <UpdatePaymentCard
                                :subscriptionDetails="subscriptionDetails"
                                :userData="userData"
                                @paymentCardUpdated:UpdatePaymentCard="handlePaymentCardUpdated"/>

                        </b-card-group>

                    </b-col>

                </b-form-row>

            </b-form>   
        </b-overlay>         
                        
                
    </span>
</template>

<script>

import ChangeSubscription from '@/components/blocks/ChangeSubscription.vue'
import genericOps from '../mixins/genericOps'
import LocalStripeService from '../services/LocalStripeService'
import UpdatePaymentCard from '@/components/blocks/UpdatePaymentCard.vue'


export default {
    name: 'SubscriptionManager',
    components: {
        ChangeSubscription,
        UpdatePaymentCard
    },
    mixins: [genericOps],
    props: {
        userData: {
            type: Object,
            default: {}
        }
    },
    
    data() {
        return {
            loading: {
                subscriptionInformation: null
            },
            subscriptionDetails: {
                created: null,
                data: null,
                end: null,
                start: null,
                cancelAt: null,
                status: null
            },
            subscriptionTable: {
                fields: [
                    {key: 'created', label: 'Created'}, 
                    {key: 'start', label: 'Next Period Begins'}, 
                    {key: 'end', label: 'Next Period Ends'}],
                items: []
            }
        }
    },
    computed: {
        localUserData: {
            get: function() {
                
                return this.userData
            
            },
            set: function(newValue) {
            }
        },
        subscriptionName: function() {
            
            return this.getNameForSubscription(this.$store.getters.getUser.subscriptionLevel)
        }
    },
    watch: {
        
    },
    created() {
        
        
        
        this.getStripeSubscription()
    },
    methods: {
        getCurrentSubscriptionName() {
            // Get the subscription name from the Stripe data (the actual current subscription)
            if (this.subscriptionDetails.data && this.subscriptionDetails.data.data) {
                const plan = this.subscriptionDetails.data.data.plan
                if (plan && plan.id) {
                    return this.getNameForSubscription(plan.id)
                }
            }
            // Fallback to user's subscription level
            return this.subscriptionName
        },
        async getStripeSubscription() {

            this.loading.subscriptionInformation = true

            this.subscriptionDetails = {}

            LocalStripeService.getSubscription(this.$store.getters.getUser.stripeSubscriptionId, this.$store.getters.getUserToken).then((response) => {

                this.subscriptionDetails.data = response.data.result

                const subData = response.data.result.data
                
                // Parse dates with validation
                if (subData.created) {
                    this.subscriptionDetails.created = new Date(Number(subData.created)*1000).toLocaleDateString()
                }
                
                // Store subscription status
                this.subscriptionDetails.status = subData.status
                
                // Period dates are in the subscription item, not at the top level
                const firstItem = subData.items && subData.items.data && subData.items.data[0]
                
                if (firstItem && firstItem.current_period_end) {
                    this.subscriptionDetails.end = new Date(Number(firstItem.current_period_end)*1000).toLocaleDateString()
                }
                
                if (firstItem && firstItem.current_period_start) {
                    this.subscriptionDetails.start = new Date(Number(firstItem.current_period_start)*1000).toLocaleDateString()
                }

                // Check if subscription is cancelled or set to cancel
                if (subData.status === 'canceled' && subData.canceled_at) {
                    // Subscription was cancelled immediately
                    this.subscriptionDetails.cancelAt = new Date(Number(subData.canceled_at)*1000).toLocaleDateString()
                } else if(subData.cancel_at && subData.cancel_at > 0) {
                    this.subscriptionDetails.cancelAt = new Date(Number(subData.cancel_at)*1000).toLocaleDateString()
                } else if (subData.cancel_at_period_end && firstItem && firstItem.current_period_end) {
                    // If cancel_at_period_end is true, use the period end date as cancellation date
                    this.subscriptionDetails.cancelAt = new Date(Number(firstItem.current_period_end)*1000).toLocaleDateString()
                }

                

                if (subData.created && firstItem) {
                    this.subscriptionTable.items.push({
                        created: new Date(Number(subData.created)*1000),
                        end: new Date(Number(firstItem.current_period_end)*1000),
                        start: new Date(Number(firstItem.current_period_start)*1000)
                    })
                }


                this.loading.subscriptionInformation = false
                

            }).catch((error) => {
                //console.log(error)
                this.loading.subscriptionInformation = false
            })

        },
        handlePaymentCardUpdated(){
            this.makeToast(true, 'Payment Card Changed', 'Payment card updated successfully.', 'success')
        },
        handleSubscriptionUpdated(data) {
            
            this.getStripeSubscription()
            
            this.$store.dispatch('updateUser', data.user)

            this.makeToast(true, 'Subscription Change', data.message, 'success')
        },
        reinstateSubscription() {
            
            let updatedSubscription = {
                cancel_at_period_end: false
            }
            
            LocalStripeService.updateSubsciption(this.$store.getters.getUser.stripeSubscriptionId, updatedSubscription, this.$store.getters.getUserToken).then((response) => {
                
                if(response.data.result.successful) {
                    this.getStripeSubscription()
                    // Refresh user data to update subscription tier in store
                    this.$store.dispatch('loadUser')
                    this.makeToast(true, 'Subscription Reinstated', 'Your subscription has been reinstated and will continue to renew automatically.', 'success')
                } else {
                    this.makeToast(true, 'Error', 'Failed to reinstate subscription. Please try again.', 'danger')
                }
                
            }).catch((error) => {
                this.makeToast(true, 'Error', 'Failed to reinstate subscription. Please try again.', 'danger')
            })
        }
    }
}
</script>

<style>

</style>

